exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".widget-purse__actions{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}", "", {"version":3,"sources":["/home/webuser/kmp3/releases/176/spa/src/components/widget-purse/WidgetPurse.vue"],"names":[],"mappings":"AAEE,uBACE,4BAAA,6BAAA,0BAAA,qBAAA,CAAA","file":"WidgetPurse.vue?vue&type=style&index=0&id=479d2fc8&prod&lang=scss","sourcesContent":["\n.widget-purse {\n  &__actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);

// exports
